"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisablePrefill = void 0;

var _get = _interopRequireDefault(require("transmute/get"));

var getDisablePrefill = (0, _get.default)('disablePrefill');
exports.getDisablePrefill = getDisablePrefill;